module.exports = __webpack_public_path__ + "static/media/Apple iPhone 7 Jet Black.5b701d59.png";